import { render } from "./AppointmentDetail.vue?vue&type=template&id=0eb24d64&scoped=true"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js"

import "./AppointmentDetail.vue?vue&type=style&index=0&id=0eb24d64&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb24d64"]])

export default __exports__